/**
 * 掌诀（六神煞）数据与文案
 *
 * 六神煞序列即指位：1=大安 2=留连 3=速喜 4=赤口 5=小吉 6=空亡
 * （算法内部用 0..5 索引）。
 * 文案做成独立数据文件，便于日后微调（产品侧可替换 summary/desc）。
 */
/** 六神煞数据（序 = 指位） */
export const ZHANGJUE_LIST = [
    {
        id: 1,
        name: '大安',
        fortune: '吉',
        summary: '安稳平顺、心宁事定',
        desc: '大安主安，身心安定、诸事平顺。谋事在稳不在急，宜守常持衡，静待时机自熟。',
    },
    {
        id: 2,
        name: '留连',
        fortune: '凶',
        summary: '纠缠拖延、暗昧不明',
        desc: '留连主滞，事多纠缠、进展迟缓，且有暗昧反复之象。宜推迟行动、缓图再进，不宜强求速成。',
    },
    {
        id: 3,
        name: '速喜',
        fortune: '吉',
        summary: '喜事临门、快速有成',
        desc: '速喜主喜，喜讯将至、谋事快成。机缘当前宜把握时机、主动行动，迟疑则易错失良机。',
    },
    {
        id: 4,
        name: '赤口',
        fortune: '凶',
        summary: '口舌是非、谨防争执',
        desc: '赤口主讼，口舌是非、多有争执。宜谨言慎行、避让锋芒，凡事先和解不先动气。',
    },
    {
        id: 5,
        name: '小吉',
        fortune: '吉',
        summary: '小有吉利、贵人财助',
        desc: '小吉主顺，小有吉利、贵人暗助。谋事渐进可成，财运小有，知足常乐则吉上加吉。',
    },
    {
        id: 6,
        name: '空亡',
        fortune: '凶',
        summary: '谋事落空、不宜妄动',
        desc: '空亡主空，谋事难成、所求易落空。宜静不宜动，及时止损、调整策略，勿执迷深究。',
    },
];
/** 按指位序号（1..6）取掌诀信息 */
export function getZhangJue(id) {
    const z = ZHANGJUE_LIST[id - 1];
    if (!z)
        throw new RangeError(`掌诀指位序号越界：${id}（应为 1..6）`);
    return z;
}
//# sourceMappingURL=zhangjue.js.map